module.exports = __webpack_public_path__ + "img/nomado.cad25837.png";